import type { ChecklistTemplate } from '../../../pages/housekeeping/types/housekeeping';
import { useTraductionsMetier } from '../../api/useTraductionsMetier';
import Text from '../../components/Text';

import CaseACocher from './CaseACocher';

/**
 * Les checklists applicables à la chambre (auto par type ∪ manuelle), comme la
 * fiche du web. Les cases cochées vivent dans la fiche : c'est elle qui décide de
 * la fin du ménage.
 */
interface BlocChecklistProps {
    templates: ChecklistTemplate[];
    coches: Set<number>;
    onBasculer: (itemId: number) => void;
    manquant: number | null;
}

export default function BlocChecklist({ templates, coches, onBasculer, manquant }: BlocChecklistProps) {
    const traductions = useTraductionsMetier(templates.flatMap((template) => (template.items ?? []).map((item) => item.label)));

    return (
        <div className="flex flex-col gap-4">
            {templates.map((template) => {
                const items = template.items ?? [];
                const faits = items.filter((item) => coches.has(item.id)).length;

                return (
                    <section key={template.id} className="flex flex-col gap-2">
                        <div className="flex items-baseline justify-between gap-2">
                            <Text variante="sousTitre" as="h2">
                                {template.name}
                            </Text>
                            <Text variante="petit" ton="attenue" as="span">
                                {faits}/{items.length}
                            </Text>
                        </div>
                        {items.map((item) => (
                            <CaseACocher
                                key={item.id}
                                libelle={traductions.libelle(item.label) ?? item.label}
                                original={traductions.libelle(item.label) ? item.label : null}
                                coche={coches.has(item.id)}
                                obligatoire={item.is_required}
                                enDefaut={manquant === item.id}
                                onChange={() => onBasculer(item.id)}
                            />
                        ))}
                    </section>
                );
            })}
        </div>
    );
}
